// Custom Logo — cerchio bianco di sfondo per far risaltare il logo ufficiale su fondo scuro
export default function Logo({ size = 44, showText = true, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <div
        className="shrink-0 rounded-full bg-white grid place-items-center shadow-[0_4px_20px_-6px_rgba(255,255,255,0.15)]"
        style={{ width: size, height: size, padding: Math.max(2, size * 0.06) }}
      >
        <img
          src="/assets/logo-icon.png"
          alt="Drago Ramen"
          className="w-full h-full object-contain"
          loading="eager"
        />
      </div>
      {showText && (
        <div className="leading-none">
          <div className="font-display text-base md:text-lg tracking-wide text-white">
            Drago <span className="text-gold">Ramen</span>
          </div>
          <div className="text-[9px] uppercase tracking-[0.28em] text-white/45 mt-1">
            Asian Restaurant
          </div>
        </div>
      )}
    </div>
  );
}

// Variante grande (per about/hero)
export function LogoLarge({ size = 140 }) {
  return (
    <div className="rounded-full bg-white grid place-items-center" style={{ width: size, height: size, padding: size * 0.05 }}>
      <img src="/assets/logo-icon.png" alt="Drago Ramen" className="w-full h-full object-contain" />
    </div>
  );
}
